import { getSession } from 'services/cognito/cognitoAccount';
import axios from 'axios';
import * as Yup from 'yup';
import { loginToRealmWithCognitoIdTokenFromSession } from 'services/realm';

// Validation schema for cloneEvent based on Swagger documentation
const cloneEventValidationSchema = Yup.object({
  eventId: Yup.string().required('eventId is required'),
  clonedEventName: Yup.string().optional(),
  cloneTeamRoles: Yup.boolean().default(false),
  eventInstancesToBeCloned: Yup.array()
    .of(
      Yup.object({
        eventInstanceId: Yup.string().required('eventInstanceId is required'),
        cloneAllDivisions: Yup.boolean().default(true),
        divisionsToBeCloned: Yup.array()
          .of(Yup.string())
          .when('cloneAllDivisions', {
            is: false,
            then: Yup.array().min(
              1,
              'At least one division must be selected when cloneAllDivisions is false'
            ),
            otherwise: Yup.array()
          }),
        cloneWorkouts: Yup.boolean().default(false),
        cloneSpectatorTickets: Yup.boolean().default(false),
        cloneVolunteerPositions: Yup.boolean().default(false)
      })
    )
    .optional()
});

export const checkIfEventSlugExists = ({ slug, excludedEventId } = {}) =>
  new Promise(async (resolve, reject) => {
    const session = await getSession();

    var config = {
      method: 'post',

      url: `${process.env.REACT_APP_BACKEND_URI}/v1/event/check-slug`,

      headers: {
        Authorization: `Bearer ${session.idToken.jwtToken}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({ slug, excludedEventId })
    };

    axios(config)
      .then(function (response) {
        console.log('data from axios request', response.data);
        resolve(response.data);
      })
      .catch(function (error) {
        console.error(error);
        reject(error);
      });
  });

export const cloneEvent = (cloneOptions = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      // Validate the input parameters
      const validatedOptions = await cloneEventValidationSchema.validate(
        cloneOptions,
        {
          abortEarly: false,
          stripUnknown: true
        }
      );

      const session = await getSession();

      var config = {
        method: 'post',

        url: `${process.env.REACT_APP_BACKEND_URI}/v1/event/clone`,

        headers: {
          Authorization: `Bearer ${session.idToken.jwtToken}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(validatedOptions)
      };

      axios(config)
        .then(async function (response) {
          console.log('data from axios request', response.data);
          // // now refreshong cognito token and re-login to realm to enable roles for this created event
          // await loginToRealmWithCognitoIdTokenFromSession(); ==> to be done in frontend page after event is created
          resolve(response.data);
        })
        .catch(function (error) {
          console.error(error);
          reject(error);
        });
    } catch (validationError) {
      console.error('Validation error:', validationError);
      reject(validationError);
    }
  });
